import { Minimap } from "./Minimap";
import { IconFit, IconMinus, IconPlus } from "./icons";
import { useUi } from "../state/ui";

/** Bottom right navigator: overview map plus zoom controls in one glass panel. */
export function Navigator({
  viewportSize,
  onZoom,
  onReset,
  onFit,
}: {
  viewportSize: () => { width: number; height: number };
  onZoom: (factor: number) => void;
  onReset: () => void;
  onFit: () => void;
}) {
  const zoom = useUi((state) => state.camera.zoom);

  return (
    <div className="navigator">
      <Minimap viewportSize={viewportSize} />
      <div className="navigator__zoom">
        <button onClick={() => onZoom(1 / 1.2)} title="Auszoomen">
          <IconMinus size={15} />
        </button>
        <button className="navigator__value" onClick={onReset} title="Auf 100 % zurücksetzen">
          {Math.round(zoom * 100)} %
        </button>
        <button onClick={() => onZoom(1.2)} title="Einzoomen">
          <IconPlus size={15} />
        </button>
        <button onClick={onFit} title="Auf Inhalt zoomen">
          <IconFit size={15} />
        </button>
      </div>
    </div>
  );
}
